
import functionRandom from 'mixins/functionRandom'

export default {
  mixins: [ functionRandom ],
  methods: {
    $_createGroupTemplate(title = null, description = '', lots = [], id = null) {
      return {
        id: id,
        title: title || `${this.$t('Tenders.Lot')} ${this.tenderMutable?.lotGroups?.length + 1 || 1}`,
        description: description,
        lots: lots
      }
    },
    $_initializeLotGroups(tender, needGuid = false) {
      const isGroupEnabled = (this.$can('show', 'useGroupLots') && tender?.biddingType?.groupedLotsEnabled) //|| !!tender?.lotGroups?.length
      if (!isGroupEnabled) {
        tender.lots = tender.lotGroups?.length
          ? tender.lotGroups.reduce((acc, lotGroup) => [...acc, ...(lotGroup.lots ?? [])], [])
          : tender.lots

        delete tender.lotGroups
        return tender
      }

      if (!tender.lotGroups) {
        tender.lotGroups = []
      }

      if (needGuid) {
        tender.lots?.map(i => i.guid = this.$_createGuid()) ?? []
      }
      let newLotGroups = []
      if (tender.lotGroups?.length) {
        tender.lotGroups?.forEach((lotGroup) => {
          let groupLots = lotGroup.lots ?? []
          if (!groupLots?.length && lotGroup.innerLotIds?.length) {
            groupLots = lotGroup.innerLotIds?.length 
              ? tender.lots.filter(lot => lotGroup.innerLotIds?.includes(lot.lotId))
              : []
          }
          const newGroup = this.$_createGroupTemplate(lotGroup.title, lotGroup.description, groupLots, lotGroup.id)
          if (needGuid) {
            newGroup.guid = this.$_createGuid() ?? []
          }
          newLotGroups.push(newGroup)
        })
      } else if (!tender.lotGroups?.length && tender.lots?.length) {
        const newGroup = this.$_createGroupTemplate(`${this.$t('Tenders.Lot')} 1`, '', [...tender.lots])
        if (needGuid) {
          newGroup.guid = this.$_createGuid() ?? []
        }

        newLotGroups = [newGroup]
      }

      tender.lotGroups = newLotGroups
      tender.lots = []
    },
  }
}